import { Component, Fragment } from 'react';

import { ReactComponent as ErrorIcon } from '../../assets/icons/toast/ErrorIcon.svg';
import { ReactComponent as SuccessIcon } from '../../assets/icons/toast/SuccessIcon.svg';
import { ReactComponent as WarningIcon } from '../../assets/icons/toast/WarningIcon.svg';

import styles from "./CustomToast.module.scss";
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import TypographyElement from '@/views/elements/typography/TypographyElement';

const cx = classNames.bind(styles);

export default function CustomToast(props: any) {
    const { titleId, message, messageId, type, trackLogId, time, } = props;
    const { t } = useTranslation()

    let isOpenTrackLogId = false
    if (trackLogId) {
        let LocalConfigWeb = JSON.parse(localStorage.getItem('LocalConfigWeb') ?? '')
        if (LocalConfigWeb && LocalConfigWeb.isOpenTrackLogId) {
            isOpenTrackLogId = LocalConfigWeb.isOpenTrackLogId
        }
    }

    return (
        <Fragment>
            <div className={cx("custom-toast")}>
                <div className={cx("toast-icon")}>
                    {
                        type === "SUCCESS" && <SuccessIcon />
                    }
                    {
                        type === "ERROR" && <ErrorIcon />
                    }
                    {
                        type === "WARN" && <WarningIcon />
                    }
                    {
                        type === "INFO" && <WarningIcon />
                    }
                </div>
                <div className={cx("container-toast")}>
                    <div className={cx('toast-title')}>
                        <TypographyElement FontSizeElement='16px' ColorElement='primary'>
                            {t(titleId) ?? titleId}
                        </TypographyElement>
                    </div>

                    {
                        (message && typeof message === 'object') ?
                            message.map((msg: string, index: number) => {
                                return (
                                    <Fragment key={index}>
                                        <div className={cx("toast-content")}>{msg}</div>
                                    </Fragment>
                                )
                            })
                            :
                            <div className={cx("toast-content")}>
                                {message ? message : (messageId ? t(messageId) : null)}
                            </div>
                    }
                    {time && (
                        <div className="date">
                            <TypographyElement FontSizeElement='12px' ColorElement='secondary'>
                                {dayjs(time).format('HH:mm:ss DD/MM/YYYY')}{type === "ERROR" && isOpenTrackLogId && trackLogId && ("|" + trackLogId.substring(0, 10))}
                            </TypographyElement>
                        </div>
                    )}
                </div>
            </div>
        </Fragment>
    );
}

export class CustomToastCloseButton extends Component {

    render() {
        return (
            <button type="button" className={cx("toast-close")} onClick={(this.props as any).closeToast}>
                {/* <i className="fa fa-fw fa-times-circle" /> */}
            </button>
        );
    }
}
